<template>
    <div class="tool-zone min-h-screen bg-slate-50" :dir="$page.props.dir">
        <SeoHead :title="title" :description="metaDescription" />
        <flash-messages />
        <tool-top-nav />
        <slot />
    </div>
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
import SeoHead from '@/Shared/SeoHead'
import ToolTopNav from '@/Shared/ToolTopNav'

export default {
    components: {
        FlashMessages,
        SeoHead,
        ToolTopNav,
    },
    props: {
        title: String,
        metaDescription: String,
    },
}
</script>
